import { VMain } from 'vuetify/lib/components/VMain';
import { VResponsive } from 'vuetify/lib/components/VResponsive';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMain,{attrs:{"id":"main-content","tabindex":"-1"}},[_c(VResponsive,[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }